// Mock data (frontend-only content) for The Monde Mania clone

export const homeSections = [
  {
    id: "music",
    title: "MUSIC",
    image: "/img/ezymnyrec.webp",
    alt: "EZ Money Records graphic",
    route: "/music",
    external: false,
    instagram: "https://www.instagram.com/ez.mnyrcrdz/",
    instagramHandle: "@ez.mnyrcrdz",
    textMark: "/img/ezmnyrcrds.webp",
    textMarkAlt: "EZ Money Records",
    paragraphs: [
      "was established in 2025 and is always looking for new talent. If you are interested submit an application on the contact page. It's pretty EZ ngl*"
    ],
    link: "https://www.instagram.com/ez.mnyrcrdz/"
  },
  {
    id: "fashion",
    title: "FASHION",
    image: "/img/fashion.png",
    alt: "fashion show graphic",
    route: "/fashion",
    external: false,
    instagram: "https://www.instagram.com/excourtier__/",
    instagramHandle: "@excourtier__",
    showWaitlist: true,
    waitlistSource: "excourtier",
    waitlistCta: "Get notified when e(x)c drops",
    paragraphs: [
      "excourtier aka e(x)c will be dropping soon."
    ],
    link: "https://www.instagram.com/excourtier__/"
  },
  {
    id: "art",
    title: "ART",
    image: "/img/art.png",
    alt: "art show graphic",
    route: "/art",
    external: false,
    paragraphs: [
      "The first Art Show is coming soon."
    ],
    link: "#"
  },
  {
    id: "events",
    title: "EVENTS",
    image: "/img/events.png",
    alt: "event graphic",
    route: "/events",
    external: false,
    paragraphs: [
      "Tap in* events coming soon!"
    ],
    link: "#"
  },
  {
    id: "services",
    title: "SERVICES",
    image: "/img/services_box.webp",
    alt: "services graphic",
    route: "/services",
    external: false,
    paragraphs: [
      "Photography, consulting, website design, graphic design, and fashion design — book the team or a member directly."
    ],
    link: "#"
  },
  {
    id: "gaming",
    title: "GAMEDEV",
    image: "/img/gamedev_box.webp",
    alt: "game development graphic",
    route: "/gaming",
    external: false,
    paragraphs: [
      "Need help building a game? Concept to deployment — tap in, or join the GameDev team."
    ],
    link: "#"
  }
];

export const pageColors = {
  index: "rgba(222,78,80,1)",
  music: "rgba(220,122,70,1)",
  fashion: "rgba(237,237,129,1)",
  art: "rgba(82,182,93,1)",
  events: "rgba(88,145,227,1)",
  services: "rgba(120,200,190,1)",
  gaming: "rgba(255,120,80,1)",
  contact: "rgba(165,103,218,1)",
  culture: "rgba(230,72,202,1)",
  shop: "rgba(206,206,202,1)",
  app: "rgba(27,27,27,1)"
};

// Placeholder products - swap out when real merch is ready.
// `visible: false` hides the product on the Shop page but keeps it in the code
// so we can bring items back later without re-authoring them.
export const products = [
  {
    id: "tmm-tee-black",
    name: "TMM Classic Tee",
    price: 38,
    image: "/img/music.png",
    description: "Heavyweight cotton tee with the TMM disco emblem printed on the chest.",
    tag: "apparel",
    visible: false
  },
  {
    id: "tmm-hoodie",
    name: "Monde Mania Hoodie",
    price: 78,
    image: "/img/fashion.png",
    description: "Cozy oversized hoodie with embroidered TMM logo. Limited seasonal drop.",
    tag: "apparel",
    visible: false
  },
  {
    id: "tmm-print-01",
    name: "Featherson Art Print",
    price: 45,
    image: "/img/art.png",
    description: "Signed A3 giclee print from the first Monde Mania art show.",
    tag: "art",
    visible: false
  },
  {
    id: "tmm-cap",
    name: "TMM Star Cap",
    price: 32,
    image: "/img/events.png",
    description: "6-panel cap with tonal TMM star embroidery and curved brim.",
    tag: "apparel",
    visible: false
  },
  {
    id: "tmm-tote",
    name: "Constellation Tote",
    price: 24,
    image: "/img/banner.png",
    description: "Heavy canvas tote featuring the TMM star field print.",
    tag: "accessories",
    visible: false
  },
  {
    id: "tmm-sticker",
    name: "Sticker Pack (x6)",
    price: 8,
    image: "/img/banner_1.png",
    description: "Six vinyl stickers of TMM iconography. Weatherproof.",
    tag: "accessories",
    visible: true
  },
  {
    id: "kv-tee",
    name: "Kore Velum Tee",
    price: 70,
    image: "/img/kvfront.png",
    description: "Kore Velum distressed gothic tee — pre-order. Sizes S–XL.",
    tag: "fashion",
    visible: true,
    link: "/brands/kore-velum"
  },
  {
    id: "sup-jacket-s",
    name: "Supreme x B.B. Simon Studded Puffer Jacket",
    price: 850,
    image: "/img/supjack.png",
    description: "White studded puffer jacket — size S.",
    tag: "fashion",
    visible: true,
    link: "/brands/supreme"
  },
  {
    id: "sbs-tee",
    name: "Swampboy Soap Tee",
    price: 12,
    image: "/img/sbs_front.webp",
    description: "Swampboy Soap white tee. Sizes S–XL.",
    tag: "fashion",
    visible: true,
    link: "/brands/swampboy-soap"
  },
  {
    id: "the-shirt",
    name: "THE SHIRT",
    price: 80,
    image: "/img/theshirt_front.jpeg",
    description: "The Monde Mania shirt — free for members. Sizes S–XXL.",
    tag: "fashion",
    visible: true,
    link: "/the-shirt"
  }
];

// Search index used by the search overlay
export const searchIndex = [
  { title: "Home", route: "/home", keywords: ["home", "landing", "main", "monde", "mania", "tmm"] },
  { title: "Music", route: "/music", keywords: ["music", "saint bruno", "ep", "sweet", "spotify", "apple"] },
  { title: "Fashion", route: "/fashion", keywords: ["fashion", "moments", "excourtier", "style", "clothing", "apparel"] },
  { title: "Art", route: "/art", keywords: ["art", "junko", "featherson", "lars larson", "sun bean", "brute", "artist", "show"] },
  { title: "Events", route: "/events", keywords: ["events", "tickets", "concert", "show", "party", "festival"] },
  { title: "Contact", route: "/contact", keywords: ["contact", "email", "reach", "message", "support"] },
  { title: "Culture", route: "/culture", keywords: ["culture", "editorial", "stories", "features"] },
  { title: "Shop", route: "/shop", keywords: ["shop", "merch", "store", "buy", "tee", "hoodie", "cap", "tote", "sticker", "print"] },
  { title: "App", route: "/app", keywords: ["app", "download", "ios", "android", "mobile"] }
];
